import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { Box, Icon, Modal, Message, Delete, Columns, Column } from 'Components/common/bulma'
import Table from 'Components/common/table'
import { getPendingList, deleteOrder, setOrigin } from 'Modules/transferOrders'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons'
import { Trans } from '@lingui/macro'
import { transferList } from './colSetup'
import { Button } from 'Components/common/bulma'
import { addNotification } from 'Modules/principal'
import { default as TransferForm } from './form'

export class ListaContainer extends Component {
  state = {
    showModal: false,
    order: {},
  }

  onEdit = (id) => {
    const { push, setOrigin } = this.props;
    setOrigin('authorize');
    push(`/ordenes-traspaso/${id}`);
  }

  toggleModal = (order) => {
    this.setState(state => ({
      showModal: !state.showModal,
      order,
    }))
  }

  deleteOrder = () => {
    this.props.deleteOrder(this.state.order.id)
      .then(() => {
        this.props.addNotification({
          type: 'success',
          message: 'La órden se eliminó correctamente'
        })
        this.setState({
          showModal: false,
        })
        this.props.getList()
      })
  }

  customColAccions = row => (
    <Fragment >
      <Button small className="margin-left-xs" primary outlined onClick={() => this.onEdit(row.id)}>
        <Icon>
          <FontAwesomeIcon icon={faEdit} />
        </Icon>
      </Button>
      <Button
        small
        className="margin-left-xs"
        danger
        outlined
        disabled={row.estatus !== '1'}
        onClick={() => this.toggleModal(row)}
      >
        <Icon>
          <FontAwesomeIcon icon={faTrash} />
        </Icon>
      </Button>
    </Fragment>
  )

  render() {
    const { list } = this.props

    return (
      <Box>
        <Modal isActive={this.state.showModal}>
          <Message danger>
            <Message.Header>
              <p>Eliminar orden de transferencia</p>
              <Delete onClick={this.toggleModal} />
            </Message.Header>
            <Message.Body className="has-text-centered">
              ¿Esta seguro de querer eliminar la orden de transferencia?
            <br />
              <strong>{this.state.order.id}</strong>
              <div className="margin-top-lg">
                <Button danger onClick={this.deleteOrder}>Eliminar</Button>
                <Button default className="margin-left-sm" onClick={this.toggleModal}>
                  Cancelar
              </Button>
              </div>
            </Message.Body>
          </Message>
        </Modal>
        <Columns>
          <Column>
            <Link className="button is-success is-outlined is-pulled-right" to="/ordenes-traspaso/nuevo">
              <Icon>
                <FontAwesomeIcon icon={faPlus} />
              </Icon>
              <Trans render="span">Agregar Orden de Traspaso</Trans>
            </Link>
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Table
              filterable
              colsetup={transferList}
              coldata={list}
              tableClassName='table is-striped is-hoverable is-fullwidth'
              emptyTableMarkUp={<span>No se encontraron registros</span>}
              customCol={{
                customColName: 'actions',
                renderFunc: this.customColAccions
              }}
              refresh={this.props.getPendingList}
            />
          </Column>
        </Columns>
      </Box>
    )
  }
}

const mapStateToProps = ({ transferOrders }) => ({
  list: transferOrders.pendingList,
  isFetching: transferOrders.isfetchingTransferOrders,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getPendingList,
  push,
  deleteOrder,
  addNotification,
  setOrigin,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListaContainer)

export {
  TransferForm
}
